const getHost = () => {
  return (process.env.REACT_APP_HOST || window.location.origin) + "/api";
};

export default getHost;
